import { render, staticRenderFns } from "./parentNotFoundPage.vue?vue&type=template&id=02be34b8"
import script from "./parentNotFoundPage.vue?vue&type=script&lang=js"
export * from "./parentNotFoundPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports